/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Market_News_Loading_List_LabelInputs */

const en_components_market_news_loading_list_label = /** @type {(inputs: Components_Market_News_Loading_List_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading market news`)
};

const de_components_market_news_loading_list_label = /** @type {(inputs: Components_Market_News_Loading_List_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marktnachrichten werden geladen`)
};

const pt_br2_components_market_news_loading_list_label = /** @type {(inputs: Components_Market_News_Loading_List_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando notícias do mercado`)
};

const tr_components_market_news_loading_list_label = /** @type {(inputs: Components_Market_News_Loading_List_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piyasa haberleri yükleniyor`)
};

const zh_cn2_components_market_news_loading_list_label = /** @type {(inputs: Components_Market_News_Loading_List_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在加载市场资讯`)
};

const zh_hk2_components_market_news_loading_list_label = /** @type {(inputs: Components_Market_News_Loading_List_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在載入市場消息`)
};

const ko_kr2_components_market_news_loading_list_label = /** @type {(inputs: Components_Market_News_Loading_List_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`시장 뉴스 불러오는 중`)
};

const ru_ru2_components_market_news_loading_list_label = /** @type {(inputs: Components_Market_News_Loading_List_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузка рыночных новостей`)
};

const es_419_components_market_news_loading_list_label = /** @type {(inputs: Components_Market_News_Loading_List_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando noticias del mercado`)
};

/**
* | output |
* | --- |
* | "Loading market news" |
*
* @param {Components_Market_News_Loading_List_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const components_market_news_loading_list_label = /** @type {((inputs?: Components_Market_News_Loading_List_LabelInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Market_News_Loading_List_LabelInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_components_market_news_loading_list_label(inputs)
	if (locale === "de") return de_components_market_news_loading_list_label(inputs)
	if (locale === "pt-BR") return pt_br2_components_market_news_loading_list_label(inputs)
	if (locale === "tr") return tr_components_market_news_loading_list_label(inputs)
	if (locale === "zh-CN") return zh_cn2_components_market_news_loading_list_label(inputs)
	if (locale === "zh-HK") return zh_hk2_components_market_news_loading_list_label(inputs)
	if (locale === "ko-KR") return ko_kr2_components_market_news_loading_list_label(inputs)
	if (locale === "ru-RU") return ru_ru2_components_market_news_loading_list_label(inputs)
	return es_419_components_market_news_loading_list_label(inputs)
});